import { useState } from "react";

export default function Welcome({ email, onDone }) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    if (!name.trim()) { setError("Please enter your name."); return; }
    setLoading(true);
    try {
      await fetch("/api/user-profile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, name: name.trim() }),
      });
      onDone(name.trim());
    } catch {
      setError("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#f7f7f5", fontFamily: "Inter, sans-serif",
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      padding: "40px 20px",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        input:focus { outline: none; border-color: #3b5bdb !important; box-shadow: 0 0 0 3px rgba(59,91,219,0.08); }
        .go-btn:hover { background: #3451c7 !important; }
      `}</style>

      <div style={{ width: "100%", maxWidth: 420, animation: "fadeUp 0.5s ease" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <span style={{ fontSize: 20, fontWeight: 800, color: "#1a1a1a" }}>PDFTopicScout</span>
          <span style={{ fontSize: 12, color: "#3b5bdb", fontWeight: 600, marginLeft: 8 }}>by Creatovate</span>
        </div>

        <div style={{
          background: "#fff", borderRadius: 16, padding: "40px 36px",
          border: "1px solid #e8e8e4", boxShadow: "0 2px 20px rgba(0,0,0,0.06)",
          textAlign: "center",
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>👋</div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: "#1a1a1a", marginBottom: 8 }}>
            Welcome aboard!
          </h1>
          <p style={{ fontSize: 15, color: "#999", lineHeight: 1.6, marginBottom: 28 }}>
            Before we find your next PDF topic,<br />what should we call you?
          </p>

          <input
            type="text"
            placeholder="Your first name"
            value={name}
            autoFocus
            onChange={e => setName(e.target.value)}
            onKeyDown={e => e.key === "Enter" && !loading && handleSubmit()}
            style={{
              width: "100%", background: "#f7f7f5", border: "1px solid #e8e8e4",
              borderRadius: 10, padding: "12px 16px", fontSize: 16,
              color: "#1a1a1a", marginBottom: 14, textAlign: "center",
              transition: "border-color 0.15s",
            }}
          />

          {error && (
            <div style={{ color: "#dc2626", fontSize: 13, marginBottom: 12 }}>{error}</div>
          )}

          <button
            className="go-btn"
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width: "100%", background: "#3b5bdb", color: "#fff",
              border: "none", borderRadius: 10, padding: "13px",
              fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "Inter, sans-serif", transition: "background 0.2s",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Saving…" : "Let's go →"}
          </button>

          <button
            onClick={() => onDone("")}
            style={{
              background: "none", border: "none", color: "#aaa",
              fontSize: 13, cursor: "pointer", marginTop: 16,
              fontFamily: "Inter, sans-serif",
            }}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
